import queryString from "query-string";
import { removeEmptyParams } from "helpers";
import { privateFetch, privateFetchNoBody } from "./fetch";

export const getUserPunchCards = async (userId, appId) => {
  const url = `${__BASE_API_URL__}/userPunchcards/${userId}?appId=${appId}`;

  try {
    const punchCards = await privateFetch(url, {
      method: "GET",
    });
    return punchCards;
  } catch (e) {
    console.error(e);
  }
};

export const getAppPunchCards = async (appId) => {
  const url = `${__BASE_API_URL__}/appPunchcards/${appId}`;

  try {
    const punchCard = await privateFetch(url, {
      method: "GET",
    });
    return punchCard;
  } catch (e) {
    console.error(e);
  }
};

export const createPunchCard = async (appId, params) => {
  // console.log("using api to create PUNCH");
  const queryParams = queryString.stringify({
    ...removeEmptyParams(params),
    appId,
  });
  const url = `${__BASE_API_URL__}/punchcard?${queryParams}`;

  try {
    const punchCard = await privateFetch(url, {
      method: "POST",
      body: JSON.stringify({
        params,
      }),
    });
    return punchCard;
  } catch (e) {
    console.error(e);
  }
};

export const updatePunchCard = async (card) => {
  // console.log("updating punchcard...");
  const { id, ...params } = card;
  // console.log(params);
  const queryParams = queryString.stringify({
    ...removeEmptyParams(params),
  });
  const url = `${__BASE_API_URL__}/punchcard/${id}?${queryParams}`;

  try {
    const punchCard = await privateFetch(url, {
      method: "PUT",
    });
    return punchCard;
  } catch (e) {
    console.error(e);
  }
};

export const deletePunchCard = async (id) => {
  // console.log("api deleting punchard with id");
  const url = `${__BASE_API_URL__}/punchcard/${id}`;

  try {
    await privateFetchNoBody(url, {
      method: "DELETE",
    });
  } catch (e) {
    console.error(e);
  }
};

export const redeemPunchCard = async (id, userId) => {
  const url = `${__BASE_API_URL__}/redeem/${id}?userId=${userId}`;

  try {
    const punchCard = await privateFetch(url, {
      method: "POST",
    });
    return punchCard;
  } catch (e) {
    console.error(e);
  }
};
